import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5em;
`;
